{
  "account-page-container": {
    "text": {
      "account": "Mein Konto",
      "logout": "Ausloggen",
      "my-appointments": "Meine Termine",
      "my-profile": "Mein Profil",
      "my-salons": "Meine Salons"
    }
  }
}
